import React from 'react';
import { InstagramPostVertical } from './InstagramPostVertical';
import { Film, MapPin, Camera, TrendingUp, Heart, Aperture, Sun, Award, Smartphone, Download, Zap, Lock } from 'lucide-react';
export function InstagramGallery() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-96">
      {/* NEW POST 1: App Launch Announcement */}
      <InstagramPostVertical title="Film Notes is Here" subtitle="Your analog photography companion" type="feature" content={<div className="space-y-6" data-id="element-98">
            <div className="flex justify-center" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/6S42RJUThA4LVcV5MgRYxz/filmnotes-fn-full-icon_1024.png" alt="Film Notes" className="w-32 h-32" data-id="element-100" />
            </div>
            <p className="text-film-black text-xl leading-relaxed text-center" data-id="element-101">
              The app film photographers have been waiting for. Track rolls, log
              frames, find labs—all in one place.
            </p>
            <div className="bg-film-black text-white p-5 text-center" data-id="element-102">
              <p className="font-display font-bold text-2xl mb-2" data-id="element-103">
                Available Now
              </p>
              <p className="text-sm opacity-80" data-id="element-104">iOS & Android</p>
            </div>
          </div>} data-id="element-97" />

      {/* NEW POST 2: App Features Overview */}
      <InstagramPostVertical title="Everything You Need" subtitle="Built for film photographers" type="feature" content={<div className="space-y-4" data-id="element-106">
            <div className="bg-white border border-film-border p-4 border-l-4 border-l-film-red" data-id="element-107">
              <div className="flex items-center gap-3 mb-2" data-id="element-108">
                <Film className="w-5 h-5 text-film-red" data-id="element-109" />
                <p className="font-display font-bold text-film-black" data-id="element-110">
                  Roll Tracking
                </p>
              </div>
              <p className="text-sm text-film-gray" data-id="element-111">
                Manage every roll from load to develop
              </p>
            </div>
            <div className="bg-white border border-film-border p-4 border-l-4 border-l-film-red" data-id="element-112">
              <div className="flex items-center gap-3 mb-2" data-id="element-113">
                <Camera className="w-5 h-5 text-film-red" data-id="element-114" />
                <p className="font-display font-bold text-film-black" data-id="element-115">
                  Frame Logging
                </p>
              </div>
              <p className="text-sm text-film-gray" data-id="element-116">
                Record settings for every shot
              </p>
            </div>
            <div className="bg-white border border-film-border p-4 border-l-4 border-l-film-red" data-id="element-117">
              <div className="flex items-center gap-3 mb-2" data-id="element-118">
                <MapPin className="w-5 h-5 text-film-red" data-id="element-119" />
                <p className="font-display font-bold text-film-black" data-id="element-120">
                  Lab Finder
                </p>
              </div>
              <p className="text-sm text-film-gray" data-id="element-121">
                Discover film labs near you
              </p>
            </div>
            <div className="bg-white border border-film-border p-4 border-l-4 border-l-film-red" data-id="element-122">
              <div className="flex items-center gap-3 mb-2" data-id="element-123">
                <Lock className="w-5 h-5 text-film-red" data-id="element-124" />
                <p className="font-display font-bold text-film-black" data-id="element-125">
                  Offline First
                </p>
              </div>
              <p className="text-sm text-film-gray" data-id="element-126">
                Your data stays private, works offline
              </p>
            </div>
          </div>} data-id="element-105" />

      {/* NEW POST 3: Download CTA */}
      <InstagramPostVertical title="Start Your Film Journey" type="feature" image="https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=800&q=80" imagePosition="full" content={<div className="space-y-6" data-id="element-128">
            <p className="text-white text-2xl leading-relaxed font-display font-bold" data-id="element-129">
              Download Film Notes today and never lose track of a roll again.
            </p>
            <div className="flex flex-col gap-3" data-id="element-130">
              <div className="bg-white text-film-black p-4 flex items-center justify-between" data-id="element-131">
                <div className="flex items-center gap-3" data-id="element-132">
                  <Smartphone className="w-6 h-6" data-id="element-133" />
                  <span className="font-display font-bold" data-id="element-134">App Store</span>
                </div>
                <Download className="w-5 h-5" data-id="element-135" />
              </div>
              <div className="bg-white text-film-black p-4 flex items-center justify-between" data-id="element-136">
                <div className="flex items-center gap-3" data-id="element-137">
                  <Smartphone className="w-6 h-6" data-id="element-138" />
                  <span className="font-display font-bold" data-id="element-139">Google Play</span>
                </div>
                <Download className="w-5 h-5" data-id="element-140" />
              </div>
            </div>
            <p className="text-white/70 text-sm text-center" data-id="element-141">
              Free to download • Pro features available
            </p>
          </div>} data-id="element-127" />

      {/* Post 1: New Roll Loaded */}
      <InstagramPostVertical title="Kodak Portra 400" subtitle="35mm • 36 Exposures" type="roll" content={<div className="bg-white border border-film-border p-6 relative" data-id="element-143">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-film-black" data-id="element-144"></div>
            <div className="pl-4 space-y-4" data-id="element-145">
              <div className="flex justify-between items-center" data-id="element-146">
                <span className="text-film-gray" data-id="element-147">Camera</span>
                <span className="font-display font-bold text-film-black text-lg" data-id="element-148">
                  Nikon FM2
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-149">
                <span className="text-film-gray" data-id="element-150">ISO</span>
                <span className="font-display font-bold text-film-black text-lg" data-id="element-151">
                  400
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-152">
                <span className="text-film-gray" data-id="element-153">Location</span>
                <span className="font-display font-bold text-film-black text-lg" data-id="element-154">
                  Brooklyn, NY
                </span>
              </div>
              <div className="mt-6 pt-4 border-t border-film-border" data-id="element-155">
                <div className="w-full bg-gray-100 h-3 rounded-full overflow-hidden" data-id="element-156">
                  <div className="bg-film-red h-full w-0" data-id="element-157"></div>
                </div>
                <span className="text-sm text-film-gray mt-2 block" data-id="element-158">
                  0/36 frames shot
                </span>
              </div>
            </div>
          </div>} data-id="element-142" />

      {/* Post 2: Lab Spotlight with Image */}
      <InstagramPostVertical title="The Darkroom" subtitle="San Clemente, CA" type="lab" image="https://images.unsplash.com/photo-1606925797300-0b35e9d1794e?w=800&q=80" imagePosition="top" content={<div className="space-y-5" data-id="element-160">
            <p className="text-film-black leading-relaxed text-lg" data-id="element-161">
              Professional C-41 and E-6 processing with same-day turnaround.
              Trusted by photographers nationwide.
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-162">
              <span className="bg-blue-50 text-blue-700 text-sm px-3 py-1.5 font-medium" data-id="element-163">
                Film Development
              </span>
              <span className="bg-blue-50 text-blue-700 text-sm px-3 py-1.5 font-medium" data-id="element-164">
                Scanning
              </span>
              <span className="bg-blue-50 text-blue-700 text-sm px-3 py-1.5 font-medium" data-id="element-165">
                Printing
              </span>
            </div>
            <div className="flex items-center gap-2 text-film-gray" data-id="element-166">
              <MapPin className="w-5 h-5" data-id="element-167" />
              <span data-id="element-168">2.3 miles away</span>
            </div>
          </div>} data-id="element-159" />

      {/* Post 3: Photography Tip */}
      <InstagramPostVertical title="Master the Sunny 16 Rule" type="tip" content={<div className="space-y-6" data-id="element-170">
            <div className="bg-film-orange/10 border-l-4 border-film-orange p-5" data-id="element-171">
              <p className="font-display font-bold text-3xl text-film-black mb-3" data-id="element-172">
                f/16 @ 1/ISO
              </p>
              <p className="text-film-gray leading-relaxed" data-id="element-173">
                On a sunny day, set aperture to f/16 and shutter speed to 1/[ISO
                value]
              </p>
            </div>
            <div className="space-y-4" data-id="element-174">
              <div className="flex items-start gap-4" data-id="element-175">
                <Sun className="w-6 h-6 text-film-orange shrink-0 mt-1" data-id="element-176" />
                <div data-id="element-177">
                  <p className="font-display font-bold text-film-black" data-id="element-178">
                    Bright Sun
                  </p>
                  <p className="text-sm text-film-gray" data-id="element-179">
                    f/16 • Perfect for midday
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-180">
                <Sun className="w-6 h-6 text-film-gray shrink-0 mt-1" data-id="element-181" />
                <div data-id="element-182">
                  <p className="font-display font-bold text-film-black" data-id="element-183">
                    Cloudy
                  </p>
                  <p className="text-sm text-film-gray" data-id="element-184">
                    f/8 • Soft, even light
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-185">
                <Sun className="w-6 h-6 text-film-black/30 shrink-0 mt-1" data-id="element-186" />
                <div data-id="element-187">
                  <p className="font-display font-bold text-film-black" data-id="element-188">
                    Shade
                  </p>
                  <p className="text-sm text-film-gray" data-id="element-189">f/5.6 • Open up more</p>
                </div>
              </div>
            </div>
          </div>} data-id="element-169" />

      {/* Post 4: Community Feature with Photo */}
      <InstagramPostVertical title="Shot by @sarah_analog" subtitle="Cinestill 800T • Leica M6" type="community" image="https://images.unsplash.com/photo-1514539079130-25950c84af65?w=800&q=80" imagePosition="full" content={<div className="space-y-4" data-id="element-191">
            <p className="text-white/90 text-xl leading-relaxed" data-id="element-192">
              "Night photography on film hits different. The grain, the glow,
              the unpredictability—it's magic."
            </p>
            <div className="flex items-center gap-2 text-white/80" data-id="element-193">
              <Heart className="w-5 h-5" data-id="element-194" />
              <span data-id="element-195">Featured in Community Picks</span>
            </div>
          </div>} data-id="element-190" />

      {/* Post 5: App Feature */}
      <InstagramPostVertical title="Track Every Frame" type="feature" content={<div className="space-y-5" data-id="element-197">
            <p className="text-film-black text-xl leading-relaxed" data-id="element-198">
              Log settings, notes, and location for each shot. Never forget what
              worked.
            </p>
            <div className="bg-white border border-film-border p-5 space-y-4" data-id="element-199">
              <div className="flex items-center gap-4" data-id="element-200">
                <div className="w-10 h-10 bg-film-red-light/20 rounded flex items-center justify-center shrink-0" data-id="element-201">
                  <Camera className="w-5 h-5 text-film-red" data-id="element-202" />
                </div>
                <div className="flex-1" data-id="element-203">
                  <p className="font-display font-bold text-film-black" data-id="element-204">
                    Frame-by-frame logging
                  </p>
                  <p className="text-sm text-film-gray" data-id="element-205">
                    Aperture, shutter, notes
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-206">
                <div className="w-10 h-10 bg-film-red-light/20 rounded flex items-center justify-center shrink-0" data-id="element-207">
                  <MapPin className="w-5 h-5 text-film-red" data-id="element-208" />
                </div>
                <div className="flex-1" data-id="element-209">
                  <p className="font-display font-bold text-film-black" data-id="element-210">
                    Auto location tagging
                  </p>
                  <p className="text-sm text-film-gray" data-id="element-211">
                    Remember where you shot
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-212">
                <div className="w-10 h-10 bg-film-red-light/20 rounded flex items-center justify-center shrink-0" data-id="element-213">
                  <Film className="w-5 h-5 text-film-red" data-id="element-214" />
                </div>
                <div className="flex-1" data-id="element-215">
                  <p className="font-display font-bold text-film-black" data-id="element-216">
                    Roll management
                  </p>
                  <p className="text-sm text-film-gray" data-id="element-217">Track all your film</p>
                </div>
              </div>
            </div>
          </div>} data-id="element-196" />

      {/* Post 6: Photographer Quote */}
      <InstagramPostVertical title="The camera is an instrument that teaches people how to see without a camera." type="quote" image="https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=800&q=80" imagePosition="full" content={<div className="space-y-5" data-id="element-219">
            <div className="h-1 w-20 bg-white/50" data-id="element-220"></div>
            <p className="text-white/90 text-2xl font-display font-bold" data-id="element-221">
              — Dorothea Lange
            </p>
            <p className="text-white/70" data-id="element-222">
              American documentary photographer and photojournalist
            </p>
          </div>} data-id="element-218" />

      {/* Post 7: Monthly Stats */}
      <InstagramPostVertical title="Your November" type="stats" content={<div className="space-y-6" data-id="element-224">
            <div className="grid grid-cols-2 gap-5" data-id="element-225">
              <div className="bg-white border border-film-border p-6 text-center" data-id="element-226">
                <p className="font-display font-bold text-5xl text-film-black mb-2" data-id="element-227">
                  12
                </p>
                <p className="text-xs text-film-gray uppercase tracking-wide" data-id="element-228">
                  Rolls Shot
                </p>
              </div>
              <div className="bg-white border border-film-border p-6 text-center" data-id="element-229">
                <p className="font-display font-bold text-5xl text-film-black mb-2" data-id="element-230">
                  432
                </p>
                <p className="text-xs text-film-gray uppercase tracking-wide" data-id="element-231">
                  Frames
                </p>
              </div>
            </div>
            <div className="bg-white border border-film-border p-5" data-id="element-232">
              <div className="flex items-center justify-between mb-3" data-id="element-233">
                <span className="text-film-gray" data-id="element-234">Most Used Film</span>
                <TrendingUp className="w-5 h-5 text-film-orange" data-id="element-235" />
              </div>
              <p className="font-display font-bold text-2xl text-film-black" data-id="element-236">
                Kodak Gold 200
              </p>
              <p className="text-sm text-film-gray mt-1" data-id="element-237">8 rolls this month</p>
            </div>
            <div className="bg-white border border-film-border p-5" data-id="element-238">
              <p className="text-film-gray mb-3" data-id="element-239">Favorite Camera</p>
              <p className="font-display font-bold text-2xl text-film-black" data-id="element-240">
                Canon AE-1
              </p>
            </div>
          </div>} data-id="element-223" />

      {/* Post 8: Film Stock Recommendation */}
      <InstagramPostVertical title="Ilford HP5 Plus" subtitle="The Classic B&W Workhorse" type="gear" image="https://images.unsplash.com/photo-1495121553079-4c61bcce1894?w=800&q=80" imagePosition="top" content={<div className="space-y-5" data-id="element-242">
            <div className="flex gap-3" data-id="element-243">
              <span className="bg-gray-200 text-film-gray text-sm px-3 py-1.5 font-medium" data-id="element-244">
                ISO 400
              </span>
              <span className="bg-gray-200 text-film-gray text-sm px-3 py-1.5 font-medium" data-id="element-245">
                B&W
              </span>
              <span className="bg-gray-200 text-film-gray text-sm px-3 py-1.5 font-medium" data-id="element-246">
                35mm
              </span>
            </div>
            <p className="text-film-black leading-relaxed text-lg" data-id="element-247">
              Versatile, forgiving, and timeless. Perfect for street photography
              and portraits. Push it to 1600 for dramatic grain.
            </p>
            <div className="bg-film-black/5 p-4 border-l-4 border-film-black" data-id="element-248">
              <p className="text-xs text-film-gray uppercase tracking-wide mb-2" data-id="element-249">
                Best For
              </p>
              <p className="text-film-black font-display font-bold" data-id="element-250">
                Street • Documentary • Portraits
              </p>
            </div>
          </div>} data-id="element-241" />

      {/* Post 9: Behind the Scenes */}
      <InstagramPostVertical title="Loading Film in the Field" type="community" image="https://images.unsplash.com/photo-1606925797300-0b35e9d1794e?w=800&q=80" imagePosition="bottom" content={<div className="space-y-5" data-id="element-252">
            <p className="text-film-black text-xl leading-relaxed" data-id="element-253">
              The ritual of loading a fresh roll. 36 frames of possibility.
            </p>
            <div className="flex items-center gap-5" data-id="element-254">
              <div className="flex items-center gap-2 text-film-gray" data-id="element-255">
                <Film className="w-5 h-5" data-id="element-256" />
                <span data-id="element-257">Kodak Portra 400</span>
              </div>
              <div className="flex items-center gap-2 text-film-gray" data-id="element-258">
                <Camera className="w-5 h-5" data-id="element-259" />
                <span data-id="element-260">Pentax K1000</span>
              </div>
            </div>
          </div>} data-id="element-251" />

      {/* Post 10: Camera Spotlight */}
      <InstagramPostVertical title="Canon AE-1 Program" subtitle="The People's Camera" type="gear" content={<div className="space-y-6" data-id="element-262">
            <div className="bg-white border border-film-border p-6 relative" data-id="element-263">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-film-black" data-id="element-264"></div>
              <div className="pl-4 space-y-4" data-id="element-265">
                <div data-id="element-266">
                  <p className="text-xs text-film-gray uppercase tracking-wide mb-2" data-id="element-267">
                    Released
                  </p>
                  <p className="font-display font-bold text-film-black text-xl" data-id="element-268">
                    1981
                  </p>
                </div>
                <div data-id="element-269">
                  <p className="text-xs text-film-gray uppercase tracking-wide mb-2" data-id="element-270">
                    Mount
                  </p>
                  <p className="font-display font-bold text-film-black text-xl" data-id="element-271">
                    Canon FD
                  </p>
                </div>
                <div data-id="element-272">
                  <p className="text-xs text-film-gray uppercase tracking-wide mb-2" data-id="element-273">
                    Modes
                  </p>
                  <p className="font-display font-bold text-film-black text-xl" data-id="element-274">
                    Program AE • Manual
                  </p>
                </div>
              </div>
            </div>
            <p className="text-film-black leading-relaxed text-lg" data-id="element-275">
              Reliable, affordable, and packed with features. The perfect first
              film camera for beginners.
            </p>
            <div className="flex items-center gap-3" data-id="element-276">
              <Award className="w-6 h-6 text-film-orange" data-id="element-277" />
              <span className="font-display font-bold text-film-black text-lg" data-id="element-278">
                Community Favorite
              </span>
            </div>
          </div>} data-id="element-261" />

      {/* Post 11: Aperture Guide */}
      <InstagramPostVertical title="Understanding Aperture" type="tip" content={<div className="space-y-5" data-id="element-280">
            <p className="text-film-black leading-relaxed text-lg" data-id="element-281">
              Master depth of field with the right f-stop choice.
            </p>
            <div className="space-y-4" data-id="element-282">
              <div className="bg-white border border-film-border p-4 border-l-4 border-l-film-orange" data-id="element-283">
                <div className="flex items-center justify-between mb-2" data-id="element-284">
                  <span className="font-display font-bold text-2xl text-film-black" data-id="element-285">
                    f/1.4 - f/2.8
                  </span>
                  <Aperture className="w-6 h-6 text-film-orange" data-id="element-286" />
                </div>
                <p className="text-sm text-film-gray" data-id="element-287">
                  Wide open • Shallow DOF • Portraits
                </p>
              </div>
              <div className="bg-white border border-film-border p-4" data-id="element-288">
                <div className="flex items-center justify-between mb-2" data-id="element-289">
                  <span className="font-display font-bold text-2xl text-film-black" data-id="element-290">
                    f/5.6 - f/8
                  </span>
                  <Aperture className="w-6 h-6 text-film-gray" data-id="element-291" />
                </div>
                <p className="text-sm text-film-gray" data-id="element-292">
                  Sweet spot • Balanced • General use
                </p>
              </div>
              <div className="bg-white border border-film-border p-4" data-id="element-293">
                <div className="flex items-center justify-between mb-2" data-id="element-294">
                  <span className="font-display font-bold text-2xl text-film-black" data-id="element-295">
                    f/11 - f/16
                  </span>
                  <Aperture className="w-6 h-6 text-film-gray" data-id="element-296" />
                </div>
                <p className="text-sm text-film-gray" data-id="element-297">
                  Stopped down • Deep DOF • Landscapes
                </p>
              </div>
            </div>
          </div>} data-id="element-279" />

      {/* Post 12: Film Photography Quote */}
      <InstagramPostVertical title="Film Forces You to Slow Down" type="quote" image="https://images.unsplash.com/photo-1495121553079-4c61bcce1894?w=800&q=80" imagePosition="full" content={<div className="space-y-5" data-id="element-299">
            <p className="text-white/90 text-2xl leading-relaxed" data-id="element-300">
              36 frames. No instant feedback. Just you, the camera, and the
              moment.
            </p>
            <div className="h-1 w-20 bg-white/50" data-id="element-301"></div>
            <p className="text-white/70 text-lg" data-id="element-302">
              That's the beauty of analog photography.
            </p>
          </div>} data-id="element-298" />
    </div>;
}